<template>
  <div class="active-addons">
    <base-heading :underline="false">{{ $t('overviewAddons.addonsTitle') }}</base-heading>
    <base-table :data="$props.activeAddons"
                :columns="columnDefinition"
                class="addons-table">
      <template #price="data">
        <p class="addon-price">{{ data.cellData.formattedValue }} <span class="addon-currency">{{ data.cellData.currencyIso }}</span></p>
      </template>
      <template #status="data">
        <p class="expiration-date">
          {{ `${$t('overviewAddons.expiresLabel')} - ${data.rowData.expirationDate}` }}
        </p>
      </template>
      <template #actions="data">
        <base-button v-if="data.rowData.canDeactivate" variant="secondary" class="addon-deactivate"  @click="deactivateAddon(data.rowData.name, data.rowData.externalId)">{{ $t('common.deactivate')}}</base-button>
      </template>
    </base-table>
  </div>
</template>

<script>
import BaseTable from '@/components/base/table/base-table'

export default {
  name: 'active-addons-table',
  components: { BaseTable },
  props: {
    activeAddons: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    columnDefinition () {
      return Object.freeze([
        {
          key: 'name',
          label: 'Naziv',
          width: '50%',
          colClass: 'addon-name'
        },
        {
          key: 'price',
          label: 'Cena',
          colClass: 'flex-grow-1',
          width: '50%',
          slot: 'price'
        },
        {
          key: 'activationDate',
          label: 'Datum aktivacije',
          colClass: 'flex-grow-1',
          width: '50%'
        },
        {
          key: 'expirationDate',
          label: 'Status',
          colClass: 'flex-grow-1',
          width: '50%',
          slot: 'status'
        },
        {
          key: 'actions',
          label: ' ',
          width: '160px',
          colClass: 'actions-slot channel-button-cell',
          slot: 'actions'
        }
      ])
    }
  },
  methods: {
    deactivateAddon (activatedName, activatedExternalId) {
      this.$emit('deactivate-addon', activatedName, activatedExternalId)
    }
  }
}
</script>

<style scoped lang="scss">
.active-addons {

  .addon-price {
    font-size: 1.6rem;
    font-weight: 600;
    margin: 0;
    color: $primary;

    .addon-currency {
      font-size: 1.4rem;
      color: $text;
      text-transform: lowercase;
    }
  }

  .addon-deactivate {
    padding: 0.8rem 3rem !important;
    min-width: auto !important;
  }
}
</style>
